import { render } from "./TheBarChart.vue?vue&type=template&id=17fc6222&scoped=true"
import script from "./TheBarChart.vue?vue&type=script&lang=js"
export * from "./TheBarChart.vue?vue&type=script&lang=js"

import "./TheBarChart.vue?vue&type=style&index=0&id=17fc6222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fc6222"]])

export default __exports__